import React from 'react';
import { Outlet, NavLink, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { Building2, ListTodo, ArrowLeft } from 'lucide-react';

export default function SuperAdminLayout() {
    const { t } = useTranslation();
    const { user } = useAuth();

    return (
        <div className="min-h-screen flex flex-col bg-gray-50">
            {/* Header */}
            <header className="bg-gray-900 text-white h-14 flex items-center px-6 shrink-0">
                <div className="flex items-center gap-3 flex-1">
                    <Building2 className="size-5 text-gray-300" />
                    <span className="font-semibold tracking-wide text-sm">Hisland Platform</span>
                    <span className="bg-violet-600 text-white text-xs font-medium px-2 py-0.5 rounded-full uppercase tracking-widest">
                        {t('superadmin.badge', 'Super Admin')}
                    </span>
                </div>
                <div className="flex items-center gap-4">
                    <Link
                        to="/dashboard"
                        className="flex items-center gap-1.5 text-gray-400 hover:text-white text-sm transition-colors"
                    >
                        <ArrowLeft className="size-4" />
                        {t('superadmin.back_to_dashboard', 'Back to Dashboard')}
                    </Link>
                    <div className="text-gray-400 text-sm">{user?.email}</div>
                </div>
            </header>

            <div className="flex flex-1 overflow-hidden">
                {/* Sidebar */}
                <nav className="w-56 bg-white border-r border-gray-200 flex flex-col py-4 shrink-0">
                    <NavLink
                        to="/superadmin/companies"
                        className={({ isActive }) =>
                            `flex items-center gap-3 px-4 py-2.5 text-sm font-medium transition-colors ${
                                isActive
                                    ? 'bg-gray-100 text-gray-900'
                                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                            }`
                        }
                    >
                        <Building2 className="size-4 shrink-0" />
                        {t('superadmin.companies', 'Companies')}
                    </NavLink>
                    <NavLink
                        to="/superadmin/audit-log"
                        className={({ isActive }) =>
                            `flex items-center gap-3 px-4 py-2.5 text-sm font-medium transition-colors ${
                                isActive
                                    ? 'bg-gray-100 text-gray-900'
                                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                            }`
                        }
                    >
                        <ListTodo className="size-4 shrink-0" />
                        {t('superadmin.audit_log', 'Audit Log')}
                    </NavLink>
                </nav>

                {/* Main content */}
                <main className="flex-1 overflow-y-auto p-6">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
